// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file currency.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file currency.proto.
 */
export const file_currency: GenFile = /*@__PURE__*/
  fileDesc("Cg5jdXJyZW5jeS5wcm90bxILZ3JwYy5hcGkudjEiOQoIQ3VycmVuY3kSCgoCaWQYASABKAMSDAoEY29kZRgCIAEoCRITCgtoYXNEZWNpbWFscxgDIAEoCEIGWgQuO3BiYgZwcm90bzM");

/**
 * Currency
 *
 * @generated from message grpc.api.v1.Currency
 */
export type Currency = Message<"grpc.api.v1.Currency"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: bool hasDecimals = 3;
   */
  hasDecimals: boolean;
};

/**
 * Describes the message grpc.api.v1.Currency.
 * Use `create(CurrencySchema)` to create a new message.
 */
export const CurrencySchema: GenMessage<Currency> = /*@__PURE__*/
  messageDesc(file_currency, 0);

